import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '../../../shared/components/header/header.component';
import { AdminSidebarComponent } from '../../sidebar/admin-sidebar.component';
import { PageHeaderComponent } from '../../../shared/components/page-header/page-header.component';
import { SftpRequestsComponent } from '../sftp-requests/sftp-requests.component';
import { ApiRequestsComponent } from '../api-requests/api-requests.component';

@Component({
  selector: 'app-admin-data-upload-requests-home',
  standalone: true,
  imports: [
    CommonModule,
    HeaderComponent,
    AdminSidebarComponent,
    PageHeaderComponent,
    SftpRequestsComponent,
    ApiRequestsComponent,
  ],
  templateUrl: './data-upload-requests-home.component.html',
  styleUrl: './data-upload-requests-home.component.scss',
})
export class AdminDataUploadRequestsHomeComponent implements OnInit {
  activeTab: 'sftp' | 'api' = 'sftp';

  constructor() {}

  ngOnInit(): void {}

  setActiveTab(tab: 'sftp' | 'api'): void {
    this.activeTab = tab;
  }
}
